export const typeformIds = {
  IHD_DETAILS: "tmxMW9gD",
  IHD_TROUBLESHOOTING: "yEtpvN3D",
  SMART_DEVICES_FEEDBACK: "vuaviFFS",
  SMART_METER_INTEREST: "e3Na4EJm",
  SMART_METERS_ACTION: "mqXrBuIn",
  SMART_METER_UNSUBSCRIBE_EMAIL: "MD3UF5i2",
} as const
